import {Badge, TableCell} from "@variocube/cube-ui";
import {DateTime} from "luxon";
import {CubeOrder, OrderStatus} from "../model";
import * as React from 'react';
import {useLocalization} from "../../i18n";

export const OrderCell = ({order}: {order?: CubeOrder}) => (
    <TableCell>
        {order && <div>{order.orderIdPrint}</div>}
        {order && <div>{DateTime.fromMillis(order.orderDate).toLocaleString(DateTime.DATE_SHORT)}</div>}
    </TableCell>
);

export const CustomerCell = ({order}: {order?: CubeOrder}) => (
    <TableCell>
        { order && <div>{order.person.lastname} {order.person.firstname}</div> }
        { order && <div>{order.email}</div> }
    </TableCell>
);

export const OrderStatusCell = ({order}: {order?: CubeOrder}) => (
    <TableCell>
        {order && <Badge>{getOrderStatusDisplay(order.orderStatus)}</Badge>}
    </TableCell>
);

function getOrderStatusDisplay(orderStatus: OrderStatus) {
    const {t} = useLocalization();
    switch (orderStatus) {
        case OrderStatus.Cleaning: return t("OrderStatusCleaning");
        case OrderStatus.Completed: return t("OrderStatusCompleted");
        case OrderStatus.Ordered: return t("OrderStatusOrdered");
        case OrderStatus.WaitingPickup: return t("OrderStatusWaitingPickup");
        case OrderStatus.WaitingReturn: return t("OrderStatusWaitingReturn");

    }
}